module.exports = __webpack_public_path__ + "static/img/ups-battery-01@m.ef93db8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lg-ess/ups-battery-01@m.jpg
// module id = /UOZ
// module chunks = 0